import React from 'react';
import qs from 'qs';
import {
  translate,
  Datagrid,
  Edit,
  List,
  SimpleForm,
  TextField,
  TextInput,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
  Filter,
  NumberField,
  Create,
  BooleanInput,
  EditButton,
  CreateButton,
  ExportButton,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import Toolbar from '@material-ui/core/Toolbar';

import updH from '../updH';
import resourceLocales from './locales';
import resourceConfig from './config';
import LinkToList from './LinkToList';
import updM from '../updM';
import exporter from '../../../../utils/exporter';
import ExportDocButton from '../docH/ExportDocButton';

const ResourceIcon = BookmarkIcon;

const listStyles = {};

const ResourceActions = ({
  bulkActions,
  basePath,
  currentSort,
  displayedFilters,
  exporter,
  filters,
  filterValues,
  onUnselectItems,
  resource,
  selectedIds,
  showFilter,
  total,
  translate,
}) => (
  <Toolbar>
    {bulkActions &&
      React.cloneElement(bulkActions, {
        basePath,
        filterValues,
        resource,
        selectedIds,
        onUnselectItems,
      })}
    {filters &&
      React.cloneElement(filters, {
        resource,
        showFilter,
        displayedFilters,
        filterValues,
        context: 'button',
      })}
    <CreateButton
      basePath={basePath}
      to={`${basePath}/create?${
        filterValues && filterValues.overEntityIds ? `_updHId=${filterValues.overEntityIds}` : ''
      }`}
    />
    <ExportDocButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
    />
  </Toolbar>
);

const MButton = (props) => {
  return (
    <updM.LinkToList
      label={`resources.${resourceConfig.name}.updM`}
      filter={{
        overEntityIds: props.record.id,
      }}
    />
  );
};

const ResourceListFilter = (props) => (
  <Filter {...props}>
    <updH.Input source="overEntityIds" label="overEntityIds" />
  </Filter>
);

const ResourceList = withStyles(listStyles)(({ classes, ...props }) => (
  <List
    {...props}
    filters={<ResourceListFilter />}
    sort={{ field: 'id', order: 'DESC' }}
    actions={<ResourceActions />}
    exporter={exporter}>
    <Datagrid>
      <TextField source={'id'} />

      <NumberField source={'price'} />
      <TextField source={'product'} />
      <NumberField source={'quantity'} />
      <NumberField source={'numberString'} />
      <TextField source={'declarationNumber'} />
      <NumberField source={'subtotal'} />

      <MButton />
      <EditButton />
    </Datagrid>
  </List>
));

const ResourceTitle = translate(({ record, translate }) => (
  <span>
    {translate(`resources.${resourceConfig.name}.name`, { smart_count: 1 })} &quot;{record.id}&quot;
  </span>
));

const ResourceCreate = (props) => {
  const defaultData = {};
  if (props.location && props.location.search && props.location.search.length > 1) {
    const params = qs.parse(props.location.search.replace(/^\?/, ''));
    if (params && params._updHId) {
      defaultData.updHId = parseInt(params._updHId);
    }
  }
  return (
    <Create {...props}>
      <SimpleForm>
        <updH.Input source={'updHId'} defaultValue={defaultData.updHId} />
        <TextInput source={'country'} />
        <TextInput source={'declarationNumber'} />
        <NumberInput source={'excise'} />
        <BooleanInput source={'hyphenCountry'} />
        <BooleanInput source={'hyphenUnit'} />
        <TextInput source={'itemVendorCode'} />
        <NumberInput source={'numberString'} />
        <NumberInput source={'price'} />
        <TextInput source={'product'} />
        <NumberInput source={'quantity'} />
        <NumberInput source={'subtotal'} />
        <NumberInput source={'subtotalWithVatExcluded'} />
        <TextInput source={'taxRate'} />
        <TextInput source={'unit'} />
        <NumberInput source={'vat'} />
        <TextInput source={'withoutExcise'} />
        <TextInput source={'attribute'} />
        <TextInput source={'unitType'} />
        <TextInput source={'country'} />
        <TextInput source={'color'} />
        <TextInput source={'colorValue'} />
        <TextInput source={'size'} />
        <TextInput source={'sizeValue'} />
        <TextInput source={'gtin'} />
        <TextInput source={'gtinValue'} />
        <TextInput source={'orderNumber'} />
        <TextInput source={'orderNumberValue'} />
      </SimpleForm>
    </Create>
  );
};

const ResourceEdit = (props) => (
  <Edit redirect={null} undoable={false} title={<ResourceTitle />} {...props}>
    <SimpleForm redirect={false}>
      <TextField source={'id'} />
      <updH.Input source={'updHId'} />

      <TextInput source={'country'} />
      <TextInput source={'declarationNumber'} />
      <NumberInput source={'excise'} />
      <BooleanInput source={'hyphenCountry'} />
      <BooleanInput source={'hyphenUnit'} />
      <TextInput source={'itemVendorCode'} />
      <NumberInput source={'numberString'} />
      <NumberInput source={'price'} />
      <TextInput source={'product'} />
      <NumberInput source={'quantity'} />
      <NumberInput source={'subtotal'} />
      <NumberInput source={'subtotalWithVatExcluded'} />
      <TextInput source={'taxRate'} />
      <TextInput source={'unit'} />
      <NumberInput source={'vat'} />
      <TextInput source={'withoutExcise'} />
      <TextInput source={'attribute'} />
      <TextInput source={'unitType'} />
      <TextInput source={'country'} />
      <TextInput source={'color'} />
      <TextInput source={'colorValue'} />
      <TextInput source={'size'} />
      <TextInput source={'sizeValue'} />
      <TextInput source={'gtin'} />
      <TextInput source={'gtinValue'} />
      <TextInput source={'orderNumber'} />
      <TextInput source={'orderNumberValue'} />
    </SimpleForm>
  </Edit>
);

const ResourceReferenceField = (props) => (
  <ReferenceField reference={resourceConfig.name} linkType={'show'} {...props}>
    <TextField source={'id'} />
  </ReferenceField>
);

const ResourceReferenceArrayField = (props) => (
  <ReferenceArrayField reference={resourceConfig.name} linkType={'show'} {...props}>
    <SingleFieldList>
      <ChipField source={'id'} />
    </SingleFieldList>
  </ReferenceArrayField>
);

const ResourceReferenceInput = (props) => (
  <ReferenceInput reference={resourceConfig.name} {...props}>
    <SelectInput optionText={'id'} />
  </ReferenceInput>
);

const ResourceReferenceArrayInput = (props) => (
  <ReferenceArrayInput reference={resourceConfig.name} {...props}>
    <SelectArrayInput optionText={'id'} />
  </ReferenceArrayInput>
);

export default {
  Icon: ResourceIcon,
  List: ResourceList,
  Title: ResourceTitle,
  Edit: ResourceEdit,
  Create: ResourceCreate,
  Field: ResourceReferenceField,
  ArrayField: ResourceReferenceArrayField,
  Input: ResourceReferenceInput,
  ArrayInput: ResourceReferenceArrayInput,
  LinkToList,

  name: resourceConfig.name,
  resourceConfig: {
    name: resourceConfig.name,
    list: ResourceList,
    // show: ResourceShow,
    icon: ResourceIcon,
    edit: ResourceEdit,
    create: ResourceCreate,
  },
  locales: resourceLocales,
  restProviderResolve: {
    name: resourceConfig.name,
    apiService: resourceConfig.apiService,
    basePath: resourceConfig.apiPath,
    schema: {},
  },
};
